
import { useStore } from "@/store";
import { computed, defineComponent } from "vue";
import { OBTER_PROJETOS, REMOVER_PROJETO } from "@/store/tipo-acoes";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Lista",
  methods: {
    excluir(id: string) {
      this.store.dispatch(REMOVER_PROJETO, id)
    }
  },
  setup() {
    const store = useStore()
    store.dispatch(OBTER_PROJETOS)
    return {
      projetos: computed(() => store.state.projeto.projetos),
      store
    }
  }
});
